/**
 * Shared LazyStudio soft-watermark brand (preview overlay + download bake).
 */

export const SOFT_WATERMARK_TEXT = "LazyStudio.ai";

/** Longest-side fraction for baked download mark (was ~0.022). */
export const SOFT_WATERMARK_FONT_RATIO = 0.034;

/** Minimum font size (px) when baking. */
export const SOFT_WATERMARK_FONT_MIN = 14;

/** Canvas edge inset (px). */
export const SOFT_WATERMARK_PAD = 16;

/** Font weight for baked + preview mark. */
export const SOFT_WATERMARK_FONT_WEIGHT = 700;

/** Default CSS inset for preview overlay (matches SoftWatermarkOverlay.css). */
export const SOFT_WATERMARK_PREVIEW_BASE_INSET = 10;

/**
 * Extra inset so the badge sits inside a rounded bottom-right corner.
 * Uses (1 - 1/√2)·R plus room for the dismiss (X) control.
 */
export function softWatermarkEdgeInsetForCornerRadius(
  cornerRadiusPx = 0,
  baseInset = SOFT_WATERMARK_PREVIEW_BASE_INSET
) {
  const r = Math.max(0, Number(cornerRadiusPx) || 0);
  if (r <= 0) return baseInset;
  const insideCurve = Math.ceil(r * (1 - Math.SQRT1_2));
  return Math.max(baseInset, insideCurve + 8);
}
